// import
import Dashboard from "views/Dashboard/Dashboard.js";
import Tables from "views/Dashboard/Tables.js";
import KYC from "views/kyc/kyc";
import Billing from "views/Dashboard/Billing.js";
// import RTLPage from "views/RTL/RTLPage.js";
import Profile from "views/Dashboard/Profile.js";
import SignIn from "views/Pages/SignIn.js";
import SignUp from "views/Pages/SignUp.js";
import Order from "views/Order/order";
import BlastForm from "views/Blast/blastForm";
import Role from "views/Role/role";
import Users from "views/Users";
import BlastChatForm from "views/Blast/chatForm";
import BlastEmailForm from "views/Blast/emailForm";
import Dashboard2 from "views/Dashboard_2";
import Report from "views/Report/report";
import Publish from "views/Publish/publish";
import Banner from "views/Banner/banner";

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
} from "components/Icons/Icons";
import { BiUserCircle } from "react-icons/bi";
import { RiFeedbackFill } from "react-icons/ri";
import { IoPlayForwardOutline } from "react-icons/io5";

var userRouter = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard2,
    layout: "/admin",
    role: 2,
  },
  {
    path: "/kyc",
    name: "Know Your Clients",
    rtlName: "لوحة القيادة",
    icon: <StatsIcon color="inherit" />,
    component: KYC,
    layout: "/admin",
    role: 2,
  },
  {
    path: "/order",
    name: "Order",
    rtlName: "لوحة القيادة",
    icon: <CreditIcon color="inherit" />,
    component: Order,
    layout: "/admin",
    role: 3,
  },
];

export const marketingAdminRoutes = [
  // {
  //   path: "/blast",
  //   name: "Blast",
  //   rtlName: "لوحة القيادة",
  //   icon: <RocketIcon color="inherit" />,
  //   component: BlastForm,
  //   layout: "/admin",
  // },
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard2,
    layout: "/admin",
    role: 2,
  },
  {
    path: "/kyc",
    name: "Know Your Clients",
    rtlName: "لوحة القيادة",
    icon: <StatsIcon color="inherit" />,
    component: KYC,
    layout: "/admin",
    role: 2,
  },
  {
    path: "/banner",
    name: "Banner",
    rtlName: "لوحة القيادة",
    icon: <SupportIcon color="inherit" />,
    component: Banner,
    layout: "/admin",
  },

  {
    path: "/blast",
    name: "BLASTING",
    category: "nested",
    rtlName: "صفحات",
    state: "pageCollapse",
    // collapse: true,
    views: [
      {
        path: "/notification",
        name: "Notification",
        rtlName: "لوحة القيادة",
        icon: <RocketIcon color="inherit" />,
        component: BlastForm,
        layout: "/admin",
      },
      {
        path: "/chat",
        name: "Chat",
        rtlName: "لوحة القيادة",
        icon: <RocketIcon color="inherit" />,
        component: BlastChatForm,
        layout: "/admin",
      },
      {
        path: "/email",
        name: "Email",
        rtlName: "لوحة القيادة",
        icon: <RocketIcon color="inherit" />,
        component: BlastEmailForm,
        layout: "/admin",
      },
    ],
  },
  {
    name: "MANAGEMENT",
    category: "nested",
    rtlName: "_",
    state: "pageCollapse",
    views: [
      {
        path: "/users",
        name: "Users",
        rtlName: "_",
        icon: <BiUserCircle color="inherit" />,
        component: Users,
        layout: "/admin",
        role: 3,
      },
    ],
  },
  {
    name: "FEEDBACK",
    category: "nested",
    rtlName: "صفحات",
    state: "pageCollapse",
    // collapse: true,
    views: [
      {
        path: "/report",
        name: "Report",
        rtlName: "لوحة القيادة",
        icon: <RiFeedbackFill color="inherit" />,
        component: Report,
        layout: "/admin",
      },
      {
        path: "/publish",
        name: "Publish",
        rtlName: "لوحة القيادة",
        icon: <IoPlayForwardOutline color="inherit" />,
        component: Publish,
        layout: "/admin",
      },
    ],
  },
];
export const superAdminRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard2,
    layout: "/admin",
    role: 2,
  },
  {
    path: "/kyc",
    name: "Know Your Clients",
    rtlName: "لوحة القيادة",
    icon: <StatsIcon color="inherit" />,
    component: KYC,
    layout: "/admin",
    role: 2,
  },
  {
    path: "/order",
    name: "Order",
    rtlName: "لوحة القيادة",
    icon: <CreditIcon color="inherit" />,
    component: Order,
    layout: "/admin",
    role: 3,
  },
  {
    path: "/blast",
    name: "BLASTING",
    category: "nested",
    rtlName: "صفحات",
    state: "pageCollapse",
    // collapse: true,
    views: [
      {
        path: "/notification",
        name: "Notification",
        rtlName: "لوحة القيادة",
        icon: <RocketIcon color="inherit" />,
        component: BlastForm,
        layout: "/admin",
      },
      {
        path: "/chat",
        name: "Chat",
        rtlName: "لوحة القيادة",
        icon: <RocketIcon color="inherit" />,
        component: BlastChatForm,
        layout: "/admin",
      },
      {
        path: "/email",
        name: "Email",
        rtlName: "لوحة القيادة",
        icon: <RocketIcon color="inherit" />,
        component: BlastEmailForm,
        layout: "/admin",
      },
    ],
  },

  {
    name: "MANAGEMENT",
    category: "nested",
    rtlName: "_",
    state: "pageCollapse",
    views: [
      {
        path: "/users",
        name: "Users",
        rtlName: "_",
        icon: <BiUserCircle color="inherit" />,
        component: Users,
        layout: "/admin",
        role: 3,
      },
      {
        path: "/role",
        name: "Role",
        rtlName: "آرتيإل",
        icon: <SupportIcon color="inherit" />,
        component: Role,
        layout: "/admin",
        role: 3,
      },
    ],
  },

  {
    name: "FEEDBACK",
    category: "nested",
    rtlName: "صفحات",
    state: "pageCollapse",
    // collapse: true,
    views: [
      {
        path: "/report",
        name: "Report",
        rtlName: "لوحة القيادة",
        icon: <RiFeedbackFill color="inherit" />,
        component: Report,
        layout: "/admin",
      },
      {
        path: "/publish",
        name: "Publish",
        rtlName: "لوحة القيادة",
        icon: <IoPlayForwardOutline color="inherit" />,
        component: Publish,
        layout: "/admin",
      },
    ],
  },
];
export const accountAdminRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard2,
    layout: "/admin",
    role: 2,
  },
  {
    path: "/kyc",
    name: "Know Your Clients",
    rtlName: "لوحة القيادة",
    icon: <StatsIcon color="inherit" />,
    component: KYC,
    layout: "/admin",
    role: 2,
  },
  {
    path: "/order",
    name: "Order",
    rtlName: "لوحة القيادة",
    icon: <CreditIcon color="inherit" />,
    component: Order,
    layout: "/admin",
    role: 3,
  },

  {
    name: "FEEDBACK",
    category: "nested",
    rtlName: "صفحات",
    state: "pageCollapse",
    // collapse: true,
    views: [
      {
        path: "/report",
        name: "Report",
        rtlName: "لوحة القيادة",
        icon: <RiFeedbackFill color="inherit" />,
        component: Report,
        layout: "/admin",
      },
      {
        path: "/publish",
        name: "Publish",
        rtlName: "لوحة القيادة",
        icon: <IoPlayForwardOutline color="inherit" />,
        component: Publish,
        layout: "/admin",
      },
    ],
  },
];

export default userRouter;
